import * as React from 'react';
import { Link } from '@reach/router';
import * as Models from 'models';

interface ArticlesListProps {
  article: Models.Article;
}

function ArticlesListItem(props: ArticlesListProps) {
  const { article } = props;

  return (
    <article key={article.title}>
      <h3><Link to={article.id}>{article.title}</Link></h3>
      <span className="date">{article.date}</span>
    </article>
  );
}

export default ArticlesListItem;